import { render } from "./PendingApproval.vue?vue&type=template&id=5ca4d2eb&scoped=true"
import script from "./PendingApproval.vue?vue&type=script&lang=js"
export * from "./PendingApproval.vue?vue&type=script&lang=js"

import "./PendingApproval.vue?vue&type=style&index=0&id=5ca4d2eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca4d2eb"]])

export default __exports__